import { DARK_MODE_CSS } from "App/DARK_MODE_CSS";
import styled, { css } from "styled-components/macro";
import {
  lightGrey,
  darkBlue,
  lightText,
  medText,
  muiButtonText,
  brightBlue,
  darkModeBackgroundColor,
  darkModeTextColor,
  darkModeTitleBackgroundColor,
  darkModeBackgroundHoveredColor,
} from "../../../constants/colors";
import {
  BREAKPOINT_NAV_HEIGHT_RESIZE,
  NAV_HEIGHT_PX,
  BREAKPOINT_MOBILE,
  BREAKPOINT_DESKTOP_XL,
  NAV_HEIGHT_MOBILE_PX,
} from "../../../constants/constants";

const WIDTH = 250;
const avatarSize = Math.floor(0.5 * WIDTH);

const DRAWER_MIN_HEIGHT_PX = 618;
const DRAWER_MIN_HEIGHT_PX_MOBILE = 565;

export const SideDrawerContentStyles = styled.div<{ $isDarkMode?: boolean }>`
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: auto 1fr;
  height: 100%;
  min-height: ${DRAWER_MIN_HEIGHT_PX_MOBILE}px;
  width: ${WIDTH}px;
  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    min-height: ${DRAWER_MIN_HEIGHT_PX}px;
  }
  overflow: auto;
  background-color: ${({ $isDarkMode }) =>
    $isDarkMode ? darkModeBackgroundColor : "white"};
  color: ${({ $isDarkMode }) =>
    $isDarkMode ? darkModeTextColor : muiButtonText};
  .MuiSvgIcon-root {
    fill: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTextColor : "currentColor"};
  }
  ${({ $isDarkMode }) => ($isDarkMode ? DARK_MODE_CSS : "")};
  .MuiButtonBase-root {
    padding: 8px 16px;
  }
  &.rightDrawer {
    .MuiTypography-root {
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : muiButtonText};
    }
  }
  &.leftDrawer {
    background-color: ${darkBlue};
    color: ${lightText};
    .list {
      padding-top: 0;
      .homeBlock {
        display: flex;
        justify-content: center;
        height: ${NAV_HEIGHT_MOBILE_PX}px;
        @media (min-width: ${BREAKPOINT_NAV_HEIGHT_RESIZE}px) {
          height: ${NAV_HEIGHT_PX}px;
        }
      }
      a:not(.home) {
        color: ${lightText};
      }
    }

    .MuiListItemIcon-root {
      color: ${lightText};
    }
    .MuiListItemText-secondary {
      font-style: italic;
      font-size: 0.8em;
      margin-left: 0.5rem;
      display: inline;
      color: ${brightBlue};
    }
    .MuiListItemText-multiline {
      display: flex;
      align-items: baseline;
    }
    .MuiListItem-button {
      height: 48px;
    }
  }
  &.filtersDrawer {
    color: ${medText};
    .listItem {
      display: block;
    }
    .dropdown {
      width: 100%;
    }
  }
  .list {
    width: ${WIDTH}px;
    display: flex;
    flex-direction: column;
    a {
      color: unset;
      text-decoration: none;
    }
  }
  .userBlock {
    padding-top: ${Math.floor(0.15 * WIDTH)}px;
    padding-bottom: ${Math.floor(0.1 * WIDTH)}px;
    width: 100%;
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTitleBackgroundColor : lightGrey};
  }
  .avatar {
    width: ${avatarSize / 1.5}px;
    height: ${avatarSize / 1.5}px;
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      width: ${avatarSize}px;
      height: ${avatarSize}px;
    }
    margin: 0px auto ${Math.floor(0.05 * WIDTH)}px auto;
  }
  .bottomBlock {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .version {
      word-break: break-all;
      margin: 8px auto 8px 8px;
    }
  }
  .name,
  .email {
    padding: 0 20px;
    word-wrap: break-word;
  }
  .selected {
    pointer-events: none;
    &.MuiButtonBase-root,
    .MuiButtonBase-root {
      background: hsla(0, 0%, 0%, 0.25);
    }
  }

  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          .MuiButton-root:hover,
          .MuiListItem-button:hover {
            background: ${darkModeBackgroundHoveredColor};
          }
        `
      : ""}
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    width: ${WIDTH * 2}px;
    overflow: hidden;
    transform: scale(2);
    transform-origin: top left;
  }
`;
